// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"_3HOJbEQGBdIumpYbXWnhSU","play":"_35ARB_h69DKgvbqWl09Z_o"};